if (!customElements.get('anniversary-jump-nav')) {
    class AnniversaryJumpNav extends HTMLElement {
        constructor() {
            super();
            // 判断是否开启跳转功能
            this.jumpAction = this.dataset.function === 'true';
            // console.log('Anniversary12thNav 构造函数:', {
            //     element: this,
            //     dataset: this.dataset,
            //     jumpAction: this.jumpAction
            // });
        }

        connectedCallback() {
            // console.log('Anniversary12thNav connectedCallback:', {
            //     jumpAction: this.jumpAction
            // });
            if (!this.jumpAction) {
                // console.log('跳转功能未启用，退出初始化');
                return;
            }
            this.initNav();
        }

        initNav() {
            // console.log('初始化导航事件监听');
            // 用事件委托，监听点击事件
            this.addEventListener('click', (e) => {
                // console.log('导航点击事件:', {
                //     target: e.target,
                //     isNavBlock: e.target.matches('.sale-nav__block'),
                //     dataset: e.target.dataset
                // });
                if (!e.target.matches('.sale-nav__block')) return;
                this.jumpFunction(e);
            })
        }
        // 跳转函数
        jumpFunction(e) {
            const target = e.target;
            const targetData = target.dataset.jump;
            // console.log('执行跳转函数:', {
            //     target: target,
            //     targetData: targetData
            // });
            // targetEl 为data-jump-id等于targetData的元素
            const targetEl = document.querySelector(`[data-jump-id="${targetData}"]`);
            // console.log('目标元素:', {
            //     selector: `[data-jump-id="${targetData}"]`,
            //     found: !!targetEl,
            //     element: targetEl
            // });
            if (!targetEl) {
                // console.warn('未找到目标跳转元素，跳转取消');
                return;
            }
            // 滚动到targetEl
            // console.log('滚动到目标元素');
            targetEl.scrollIntoView({
                behavior: 'smooth',
                block: 'start',
            });
        }
    }
    customElements.define('anniversary-jump-nav', AnniversaryJumpNav);
    // console.log('AnniversaryJumpNav 组件已注册');
}